import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
}
export function CTAButton({
  label = 'ÚNETE AL ENTRENAMIENTO',
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'lg' ? 'px-8 py-5 text-base md:text-lg' : 'px-6 py-3.5 text-sm md:text-base';
  return <motion.a href="https://chat.whatsapp.com/HBZu8gNMYTAGoB4laO8PqY?mode=gi_t" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group relative inline-flex items-center justify-center gap-3 ${sizeClasses} rounded-full bg-terracotta text-cream font-semibold tracking-wide uppercase shadow-2xl shadow-terracotta/20 hover:bg-terracotta-dark transition-colors overflow-hidden ${className}`} data-id="element-181">
      <span className="absolute inset-0 rounded-full bg-gold/20 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-182"></span>
      <span className="relative" data-id="element-183">{label}</span>
      <ArrowRight className="relative w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-184" />
    </motion.a>;
}